import React from "react";
import { FileDownload } from "@mui/icons-material";

import { getCurrentProject } from "fond/project";
import { useLayerPanelContext } from "fond/project/panels/InputPanel/LayerPanelContext";
import { useAppSelector } from "fond/utils/hooks";
import { Actions, permissionCheck } from "fond/utils/permissions";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

/**
 * `LayerPanel` action for exporting the layer.
 */
const LayerExportAction: React.FC = () => {
  const { layerKey } = useLayerPanelContext();
  const { open } = useStackedNavigationContext();
  const project = useAppSelector((state) => getCurrentProject(state.project));
  const canViewExport = permissionCheck(project?.Permission?.Level, Actions.PROJECT_EXPORT_VIEW);

  if (!canViewExport) return null;

  return (
    <StackedNavigationButton
      data-testid={`export-${layerKey}-button`}
      icon={<FileDownload />}
      title="Export Layer"
      subtitle="Download layer data"
      onClick={() => open(`${layerKey}-export`)}
    />
  );
};

export default LayerExportAction;
